export default __webpack_public_path__ + "static/media/tf.75f62b39.svg";